export default "__VITE_ASSET__C4$S5muD__"